import axios from "axios";

export default axios.create({
    baseURL:"https://wns-sentry-dev.sony.eu/tne/tneapi/v1",
    headers: {
        'Content-Type': 'application/json'
      }
});